/* ph-pdp: ideal product page behaviour, added 10 Oct 2026. */
(() => {
  if (window.__phPdp) return; window.__phPdp = 1;
  const $ = (s, r = document) => r.querySelector(s);

  /* 3. Payflex line: reuse the amount the official Payflex widget calculates (hidden by CSS). */
  const line = $('[data-ph-pdp-payflex]');
  if (line) {
    const sync = () => {
      const amt = $('#payflexCalculatorWidget #pay-in-amount');
      const t = amt && amt.textContent.trim();
      if (t) { line.textContent = 'Or pay from ' + t + ' today with Payflex, 0% interest'; line.hidden = false; return true; }
      return false;
    };
    if (!sync()) { const mo = new MutationObserver(() => { if (sync()) mo.disconnect(); }); mo.observe(document.body, { childList: true, subtree: true }); setTimeout(() => mo.disconnect(), 20000); }
    document.addEventListener('variant:change', () => setTimeout(sync, 800));
  }
  const dlg = $('#PhPdpPayDrawer');
  if (dlg) {
    if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-ph-pdp-pay-open]')) { dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''); }
      else if (e.target.closest('[data-ph-pdp-pay-close]') || e.target === dlg) dlg.close();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && dlg.open) dlg.close(); }, true);
  }

  /* 12. Ask a stylist: reuse the existing WhatsApp form launcher (same hook as the FAB). */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-ph-pdp-whatsapp]')) return;
    e.preventDefault();
    const el = $('.partners-help-mobile [data-partners-whatsapp-open]') || $('[data-partners-whatsapp-open]');
    if (el) el.click(); else window.open('https://wa.me/27636790388', '_blank', 'noopener');
  });

  /* FAB: dock it inside the sticky add-to-cart bar; hidden whenever the bar is not showing (see ph-pdp.css). */
  const html = document.documentElement;
  html.classList.add('ph-pdp-page');
  const sticky = $('.product-sticky-form__card');
  const dock = () => {
    const cs = sticky && getComputedStyle(sticky);
    const on = !!sticky && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.1 && sticky.getBoundingClientRect().top < window.innerHeight;
    html.classList.toggle('ph-pdp-fab-dock', on);
    if (on) { const r = sticky.getBoundingClientRect(); html.style.setProperty('--ph-pdp-fab-bottom', Math.max(8, Math.round(window.innerHeight - r.bottom + (r.height - 48) / 2)) + 'px'); }
  };
  if (sticky) {
    new MutationObserver(dock).observe(sticky, { attributes: true, attributeFilter: ['class', 'style'] });
    window.addEventListener('scroll', dock, { passive: true });
    window.addEventListener('resize', dock, { passive: true });
  }
  dock();

  /* 9. Complete the routine (Shopify complementary recommendations). */
  const box = $('[data-ph-pdp-routine]');
  if (!box) return;
  const fmt = (cents) => {
    const f = (box.dataset.moneyFormat || 'R{{amount}}').replace(/<[^>]*>/g, '');
    const v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  fetch(root + 'recommendations/products.json?product_id=' + box.dataset.productId + '&limit=6&intent=complementary')
    .then((r) => r.ok ? r.json() : { products: [] })
    .then((data) => {
      const recs = (data.products || []).map((p) => ({ p, v: (p.variants || []).find((v) => v.available) })).filter((x) => x.v && x.p.id != box.dataset.productId).slice(0, 2);
      if (!recs.length) return;
      const items = [];
      if (box.dataset.available === 'true') items.push({ id: +box.dataset.variantId, title: box.dataset.title, price: +box.dataset.price, img: box.dataset.image, url: box.dataset.url, current: true });
      recs.forEach(({ p, v }) => items.push({ id: v.id, title: p.title, price: v.price, img: p.featured_image, url: p.url }));
      if (items.length < 2) return;
      $('[data-ph-pdp-routine-items]', box).innerHTML = items.map((i) =>
        `<li class="ph-pdp-routine__item"><img src="${esc(i.img || '')}" alt="" loading="lazy" width="56" height="56"><a href="${esc(i.url)}">${esc(i.title)}${i.current ? '<small>This item</small>' : ''}</a><span class="ph-pdp-routine__price">${fmt(i.price)}</span></li>`).join('');
      $('[data-ph-pdp-routine-total]', box).textContent = fmt(items.reduce((s, i) => s + i.price, 0));
      if (box.dataset.available !== 'true') $('[data-ph-pdp-routine-msg]', box).textContent = 'This item is sold out, so it is not included.';
      box.hidden = false;
      const btn = $('[data-ph-pdp-routine-add]', box), msg = $('[data-ph-pdp-routine-msg]', box);
      btn.addEventListener('click', async () => {
        btn.disabled = true; msg.textContent = 'Adding…';
        try {
          const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items.map((i) => ({ id: i.id, quantity: 1 })) }) });
          const j = await r.json();
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add');
          const cart = await (await fetch(root + 'cart.js')).json();
          if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'ph-pdp-routine', cart });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          msg.textContent = 'Added ' + items.length + ' items to your cart.';
        } catch (err) { msg.textContent = err.message; }
        btn.disabled = false;
      });
    }).catch(() => {});
})();
